import "./index.css";
import "./App.css";
import CssBaseline from "@mui/material/CssBaseline";
import { ThemeProvider } from "@mui/material";
import baseTheme from "../src/themes/baseTheme";
import React, { useState, useEffect } from "react";
import { Routes, Route, useLocation } from "react-router-dom";

// import Login from "./pages/Login";
import Login from "./pages/Login/login";
import contentDataEN from "../src/utils/contentEN.json";
import contentDataES from "../src/utils/contentEN.json";

import ForgetPassword from "./pages/forget-password/forget-password";
// import Myaccount from "./components/pages/Myaccount/Myaccount";
import i18n from "./Localization/i18n";

// import DashboardMyaccount from "./components/pages/dashboard-myaccount/dashboard-myaccount";

// import Users_Rols from "./components/pages/Settings/Users&Roles/Users_Roles";
import EditClient from "./pages/AdminDashboard/ClientReview/EditClient";
// import EditAdmin from "./components/pages/Settings/EditAdmin/EditAdmin";
// import AdminAccount from "./components/pages/Settings/Users&Roles/AdminAccount";
// import Dashboard from "./components/pages/Dashboard";
// import RecentDocuments from "./components/pages/RecentDocuments";
//import MenuHeader from "./components/pages/MenusHeader";

import ProtectedRoute from "./ProtectedRoute";
import ProtectedLayout from "./ProtectedLayout";
import VendorSearch from "./pages/VendorSearch";
import InviteVendor from "./pages/InviteVendor/InviteVendorTab";
// import CustomReports from "./pages/CustomReports";
import FourNaughtFour from "./pages/404";
import { ToastContainer, toast } from "react-toastify";
import Registeration from "./pages/registeration/Registeration";
import PasswordUpdate from "./pages/password-update/password-update";
import SetNewPassword from "./pages/set-password/set-password";
import RegisterationOption from "./pages/registeration-option/registeration-option";
import Newregisteration from "./pages/newregisteration/newregisteration";
import AdminDashboard from "./pages/AdminDashboard/Dashboard/index";
import DashboardRecentDocuments from "./pages/AdminDashboard/DashboardRecentDocument/index";
import DashboardAnalytics from "./pages/AdminDashboard/DashboardAnalytics";
import SettingsTab from "./pages/Settings/SettingsTab";
import UserDetails from "./pages/Settings/Users&Roles/UserDetails/UserDetails";
import UserDetail from "./pages/Settings/Users&Roles/UserDetails/UserDetails";
import Myaccount from "./pages/Myaccount/Myaccount";
import FinacialAnalyticsTabs from "./pages/financialanalytics/FinancialAnalytics/FInacialAnalyticsTabs";
import "./App.css";
import EdiitAdmin from "./pages/Settings/EditAdmin/EditAdmin";
import VenderDetails from "./pages/AdminDashboard/Vendor/VendorDetails";
import Terms_and_Conditions from "./reusable-components/footer/Terms_and_Conditions/Terms_and_Conditions";
import Statement_of_Privacy from "./reusable-components/footer/Statement of Privacy/Statement_of_Privacy";
import Contact_us from "./reusable-components/footer/Contactus/Contact_us";
import FinancialAnalytics from "./pages/financialanalytics/FinancialAnalytics/FinancialAnalytics";
import FinancialData from "./pages/financialanalytics/FinancialData/FinancialData";
import MainInformation from "./pages/financialanalytics/FinancialData/MainInformation";
import Payment from "./components/Questionnaire/Payment/Payment";
import EvaluationsDataEntry from "./pages/AdminDashboard/Vendor/EvaluationsDataEntry";
import EmployeeList from "./pages/AdminDashboard/Training/EmployeeList";
import AddEmployee from "./pages/AdminDashboard/Training/AddEmployee";
import AddToCart from "./pages/AdminDashboard/Training/Trainingcart/TraningCartTabs";
import EmployeeAccess from "./pages/AdminDashboard/Training/EmployeeAccess";
import OnsiteorOffsite from "./pages/AdminDashboard/Onsite And Offsite/OnsiteorOffsite";
import PaymentSuccess from "./components/Questionnaire/Payment/PaymentSuccess";
import CustomReports from "./pages/AdminDashboard/CustomReport/CustomReportTab";
import EmployeeFirstLogin from "./pages/AdminDashboard/Training/EmployeeFirstLogin";
import EmployeeSignature from "./pages/AdminDashboard/Training/EmployeeSignature";
import EditVendor from "./pages/AdminDashboard/EditVendor/EditVendor";
import DashboardAdminDocument from "./pages/AdminDashboard/DashboardAdminDocument";
import Notifications from "./pages/AdminDashboard/Notifications";
import StatusDescription from "./pages/AdminDashboard/StatusDescription/StatusDescription";
import { HasPermissions, getOrgType, getisEmp } from "./utils/Token";
import INFO from "./utils/Enums.json";
import CoimpaniesTab from "./pages/Settings/Companies/CompaniesTab";
import { UsersProvider } from "./store/users-context";
import { ChecklistProvider } from "./store/checklist-context";
import CheckLists from "./pages/template-tool/checklist/CheckLists";
import CheckListDetails from "./pages/template-tool/checklist/CheckListDetails";
import CheckListQuestionDetail from "./pages/template-tool/checklist/CheckListQuestionDetail";
import ClientQuestionnaireTab from "./pages/ClientQuestionnaires/ClientQuestionnaireTab";
import StartPrequlications from "./pages/ClientQuestionnaires/StartPrequlications";
import NewCompany from "./pages/Settings/Companies/NewCompany";
import PrequlificationAnalyticsTab from "./pages/AdminDashboard/PrequlificationAnalytics/PrequlificationAnalyticsTab";
import { GlobalComponentProvider } from "./pages/commom/GlobalComponentProvider";
import { QuestionnaireProvider } from "./store/questionnaire-context";
import Employees from "./pages/AdminDashboard/Training/Employees";
import TrainingAddToCart from "./pages/AdminDashboard/Training/TrainingAddToCart";
import VendorDashboard from "./pages/vendor-dashboard/VendorDashboard";
import UploadEmployees from "./pages/AdminDashboard/Training/UploadEmployees";
import PaymentSuccessForTraining from "./pages/AdminDashboard/Training/PaymentSuccessForTraining";
import EmployeeDocuments from "./pages/AdminDashboard/Training/EmployeeDocuments";
import UserActivation from "./pages/registeration/UserActivation";
import FVInviteVendor from "./pages/registeration/FVInviteVendor";
import ClientDashboard from "./pages/AdminDashboard/Dashboard/ClientDashboard";
import ClientVendorsInvited from "./pages/InviteVendor/ClientVendorsInvited";
import EmployeeSelfRegistration from "./pages/registeration/EmployeeSelfRegistration";
import EmailtemplateList from "./pages/AdminDashboard/Vendor/Email/EmailTemplateList";
import Help from "./pages/Myaccount/Help";
import ContentPage from "./components/Widget/ContentPage";
import SearchUserNames from "./pages/VisitorManagement/SearchUserNames";
import CheckinCheckout from "./pages/VisitorManagement/CheckinCheckout";
import GenerateCode from "./pages/VisitorManagement/GenerateCode";
import GenerateCodePop from "./pages/VisitorManagement/GenerateCodePop";
import TemplatesAndSectionsTab from "./pages/template-tool/TemplatesAndSectionsTab";
import ImportInvitationsToFV from "./pages/registeration/ImportInvitationsToFV";
import EmployeeVendorSelfRegistration from "./pages/registeration/EmployeeVendorSelfRegistration";
import LoginEmailVerification from "./pages/Login/LoginEmailVerification";
import LoginVerification from "./pages/Login/LoginVerification";
import SubscriptionFeeDetails from "./pages/AdminDashboard/SubscriptionFee/SubscriptionFeeDetails";

function App() {
  const location = useLocation();
  const [redirectTo] = useState(
    location.pathname === "/" ? "/DashBoard" : location.pathname
  );

  const [languageFlag, setLanguageFlag] = React.useState("EN");
  const [languageContent, setLanguageContent] = React.useState(contentDataEN);

  const navigating =
    getisEmp() === "true"
      ? "/EmployeeQuizzes"
      : getOrgType() === "Client"
      ? "/GetClientEmployees"
      : getOrgType() === "Vendor"
      ? "/EmployeesList"
      : "/EmployeesList";

  // getOrgType() === "Client" ? "GetClientEmployees" :
  // getOrgType() === "Vendor" ? "/EmployeesList" :
  const channel = new BroadcastChannel("refresh_channel");

  // Listen for the refresh message and reload the page when received
  channel.onmessage = (message) => {
    if (message.data === "refresh") {
      window.location.reload();
      window.location = "/DashBoard";
    } else if (message.data === "refresh1") {
      window.location.reload();
      window.location = "/EmployeeSignature";
    } else if (message.data === "refresh2") {
      window.location.reload();
    } else if (message.data === "refresh3") {
      window.location.reload();
      window.location = "/";
    }
  };
  return (
    <>
      {/* <ToastContainer /> */}
      <GlobalComponentProvider>
        <ThemeProvider theme={baseTheme}>
          <CssBaseline />
          <Routes>
            {/* <Route index element={<div>Landing page</div>} /> */}
            <Route
              path="/Registration"
              element={<Registeration content={languageContent} />}
            />
            <Route
              path="/forgot-password"
              element={<ForgetPassword content={languageContent} />}
            />
            <Route
              path="/password-update"
              element={<PasswordUpdate content={languageContent} />}
            />
            <Route
              path="/Lookupusername"
              element={<SearchUserNames content={languageContent} />}
            />
            <Route
              path="/new-password"
              element={<SetNewPassword content={languageContent} />}
            />
            <Route
              path="/registration-option"
              element={<RegisterationOption content={languageContent} />}
            />
            <Route
              path="/registration-company"
              element={<Newregisteration content={languageContent} />}
            />
            <Route
              path="/terms_and_conditions"
              element={<Terms_and_Conditions content={languageContent} />}
            />
            <Route
              path="/Statement_of_Privacy"
              element={<Statement_of_Privacy content={languageContent} />}
            />
            {/* <Route
              path="/Help"
              element={<Help />}
            /> */}
            <Route
              path="/Contact_us"
              element={<Contact_us content={languageContent} />}
            />
            <Route
              index
              element={
                <Login content={languageContent} language={languageFlag} />
              }
            />
            <Route
              path="/EmpSelfRegistration"
              element={<EmployeeSelfRegistration />}
            />
            <Route
              path="/EmployeeSelfRegistration"
              element={<EmployeeVendorSelfRegistration />}
            />
            <Route
              path="/login"
              element={
                <Login content={languageContent} language={languageFlag} />
              }
            />

            <Route
              path="/LoginEmailVerification"
              element={<LoginEmailVerification />}
            />
            <Route path="/LoginVerification" element={<LoginVerification />} />

            <Route
              path="/Common/ImportInvitationsToFV"
              element={<ImportInvitationsToFV />}
            />

            <Route
              path="/Process/UserActivation"
              element={<UserActivation />}
            />
            <Route path="/Process/InviteVendor" element={<UserActivation />} />

            <Route
              path="/Process/FVInviteVendor"
              element={<FVInviteVendor />}
            />
            <Route
              path="/Process/FVInviteVendor"
              element={<FVInviteVendor />}
            />

            <Route element={<ProtectedRoute />}>
              <Route
                path="/EmployeeSignature"
                element={<EmployeeSignature />}
              />

              {/* <Route
                path="/content"
                element={<ContentPage />}
              /> */}
              <Route
                path="/EmailTemplatelist"
                element={<EmailtemplateList />}
              />
              <Route element={<ProtectedLayout />}>
                <Route
                  path="/PaymentSuccess"
                  element={
                    <QuestionnaireProvider>
                      <PaymentSuccess />
                    </QuestionnaireProvider>
                  }
                />
                <Route path="/Help" element={<Help />} />
                <Route
                  path="/Addticart"
                  index
                  element={<TrainingAddToCart />}
                />
                <Route
                  path={"/DashBoard"}
                  index
                  element={
                    getisEmp() === "false" ? (
                      getOrgType() == "Admin" ? (
                        <AdminDashboard />
                      ) : getOrgType() == "Vendor" ? (
                        <VendorDashboard />
                      ) : getOrgType() == "Client" ||
                        getOrgType() == "Super Client" ? (
                        <ClientDashboard />
                      ) : (
                        // "Client Dashboard"
                        "YOU DONT HAVE A PERMISSIONS"
                      )
                    ) : (
                      "YOU DONT HAVE A PERMISSIONS TO ACCESS THIS PAGE"
                    )
                  }
                />
                <Route
                  path="/EvaluationsDataEntry"
                  element={<EvaluationsDataEntry />}
                />
                <Route path="/finacialData" element={<FinancialData />} />
                <Route path="/MainInformation" element={<MainInformation />} />
                <Route
                  path="/EmployeesListForSeclectedClientAndVendor"
                  element={<EmployeeList />}
                />
                <Route path={navigating} element={<Employees />} />
                {/* <Route path="/AddEmployee" element={<AddEmployee />} /> */}
                <Route path="/EditVendor" element={<EditVendor />} />
                <Route path="/EditClient" element={<EditClient />} />
                <Route path="/AddEmployees" element={<AddEmployee />} />
                <Route path="/UploadEmployees" element={<UploadEmployees />} />
                <Route
                  path="/EmployeeFirstLogin"
                  element={<EmployeeFirstLogin />}
                />
                <Route
                  path="/PaymentsuccessForTraining"
                  element={<PaymentSuccessForTraining />}
                />
                <Route
                  path="/EmployeeDocuments"
                  element={<EmployeeDocuments />}
                />
                {/* <Route path="/AddToCart" element={<AddToCart />} /> */}
                {[
                  "AddToCart",
                  "/MoodleAssignBulkTrainings",
                  "/QuizPayments",
                ]?.map((r) => (
                  <Route path={r} element={<AddToCart />} />
                ))}
                <Route path="/EmployeeAccess" element={<EmployeeAccess />} />
                <Route path="/Get" element={<OnsiteorOffsite />} />
                <Route
                  path="/recentDocuments"
                  element={<DashboardRecentDocuments />}
                />
                <Route
                  path="/EmployeeCheckinCheckout"
                  element={<CheckinCheckout />}
                />{" "}
                {/* Visitor Management */}
                <Route
                  path="/GenerateEmployeeCheckinCode"
                  element={<GenerateCode />}
                />{" "}
                <Route
                  path="/EmployeeCheckinCode"
                  element={<GenerateCodePop />}
                />
                {/* Visitor Management */}
                <Route
                  path="/StatusDescription"
                  element={<StatusDescription />}
                />
                <Route path="/Notification" index element={<Notifications />} />
                <Route
                  path="/adminDocument"
                  element={<DashboardAdminDocument />}
                />
                <Route path="/AddNewCompany" element={<NewCompany />} />
                <Route
                  path="/DashboardAnalytics"
                  element={<DashboardAnalytics />}
                />
                <Route
                  path="/PowerBiReports"
                  element={<PrequlificationAnalyticsTab />}
                />
                <Route
                  path="/ClientVendorsInvited"
                  element={<ClientVendorsInvited />}
                />{" "}
                {/* new one */}
                <Route path="/VendorSearch" element={<VendorSearch />} />
                <Route
                  path={"/VendorDetails" || "/Vendordetails"}
                  element={
                    <QuestionnaireProvider>
                      {" "}
                      <VenderDetails />{" "}
                    </QuestionnaireProvider>
                  }
                />
                <Route
                  path="/ClientAndAdminViewFinancialAnalytics"
                  element={<FinacialAnalyticsTabs />}
                />
                <Route
                  path="/payment"
                  element={
                    <QuestionnaireProvider>
                      <Payment />
                    </QuestionnaireProvider>
                  }
                />
                <Route path="/InviteVendor" element={<InviteVendor />} />
                <Route path="*" element={<FourNaughtFour />} />
                <Route path="/edituser" element={<EdiitAdmin />} />
                <Route path="/CustomReports" element={<CustomReports />} />
                {["/MyAccount", "/ChangePassword", "/MyCompanyDetails"]?.map(
                  (r) => (
                    <Route
                      path={r}
                      element={
                        HasPermissions(
                          INFO?.Screens?.MyAccount,
                          INFO?.ScreenPermissions?.Read
                        ) ? (
                          <Myaccount />
                        ) : (
                          "YOU DONT HAVE A PERMISSIONS"
                        )
                      }
                    />
                  )
                )}
                <Route
                  path="/SubscriptionFeePaymentHistory"
                  element={<SubscriptionFeeDetails />}
                />
                {[
                  "/SearchUser",
                  "/BiddingInterestsList",
                  "/InstructionBanner",
                  "/MyContractorEvaluations",
                  "/AddPowerBiPermissions",
                  "/AddDepartments",
                  "/ManageSites",
                  "/SearchCompany",
                  "/AddSystemRole",
                  "/EmailTemplatesList",
                  "/EmailVendor",
                  "/ManageNotifications",
                  "/ManageInvitationNotifications",
                  "/AddInvitationTemplates",
                  "/AddInviteNotifications",
                  "/CronjobNotificationSetup",
                  "/NotificationsSetup",
                  "/AssignRoles",
                  "/ClientOrVendorUsersList",
                  "/DocumentTypesList",
                  "/ProficiencyCapabilitiesList",
                  "/MyCompanyDetails",
                  "/EmailTemplatesList",
                  "/ClaycoBiddingInterestsList",
                  "/CourseInstructions",
                  "/UploadImages",
                  "/SubscriptionFee",
                  "/MFAConfiguration",
                ]?.map((r) => (
                  <Route
                    path={r}
                    element={
                      <UsersProvider>
                        <SettingsTab />
                      </UsersProvider>
                    }
                  />
                ))}
                <Route
                  path="/userdetails"
                  element={
                    <UsersProvider>
                      <UserDetails />
                    </UsersProvider>
                  }
                />
                <Route path="/UserDetail" element={<UserDetail />} />
                {/* <Route path="/SearchCompany" element={<CoimpaniesTab />} /> */}
                {[
                  "/TemplatesAndSections",
                  "/CreateCustomTemplate",
                  "/QuestionsBank",
                  "/AssignedTemplatesList",
                  "/CopyInformation",
                  "/QuizTemplatesAndSections",
                  "/CreateMoodleTemplate",
                  "/VisitorManagement",
                ]?.map((r) => (
                  <Route
                    path={r}
                    element={
                      <UsersProvider>
                        <TemplatesAndSectionsTab />
                      </UsersProvider>
                    }
                  />
                ))}
                {/* <Route
                  path="/TemplatesAndSections"
                  element={<TemplatesAndSections tab={"Standard"} />}
                />
                <Route
                  path="/CreateCustomTemplate"
                  element={<TemplatesAndSections tab={"Custom"} />}
                />
                <Route
                  path="/VisitorManagement"
                  element={<TemplatesAndSections tab={"VisitorManagement"} />}
                /> */}
                <Route
                  path="/CheckLists"
                  element={
                    <ChecklistProvider>
                      {" "}
                      <CheckLists />{" "}
                    </ChecklistProvider>
                  }
                />
                <Route
                  path="/CheckListDetails"
                  element={
                    <ChecklistProvider>
                      {" "}
                      <CheckListDetails />{" "}
                    </ChecklistProvider>
                  }
                />
                <Route
                  path="/CheckListQuestionDetail"
                  element={
                    <ChecklistProvider>
                      {" "}
                      <CheckListQuestionDetail />{" "}
                    </ChecklistProvider>
                  }
                />
                <Route
                  path="/ListOfPotentialClients"
                  element={<ClientQuestionnaireTab />}
                />
                <Route
                  path="/TemplatesList"
                  element={<StartPrequlications />}
                />
              </Route>
            </Route>
          </Routes>
        </ThemeProvider>
      </GlobalComponentProvider>
    </>
  );
}
export default App;
